
interface Binding {
  x: number
  y: number
}
export default {
  //   ob: MutationObserver.prototype,
  mounted (el: any, binding: Binding): void {
    let x = 0
    let y = 0
    let startX = 0
    let startY = 0
    let oldX = x
    let oldY = y
    let isStart = false
    el.onmousedown = (e: any) => {
      startX = e.clientX
      startY = e.clientY
      oldX = x
      oldY = y
      isStart = true
    }
    el.onmousemove = (e: any) => {
      if (!isStart) return
      y = oldY - (startY - e.clientY)
      x = oldX - (startX - e.clientX)
      el.style.transform = `translate(${x}px, ${y}px)`
    }
    el.onmouseup = () => {
      isStart = false
    }
    el.onmouseleave = () => {
      isStart = false
    }
  },
  unmounted (el: Element): void {
  }
}
